<template>
  <div style="padding-bottom: 50px">
    <!-- <div class="top c-p-20">
      <span>卡种选择(必选,单选)</span>
    </div> -->
    <g-title title="卡种选择" class="c-p-tb-10 c-p-lr-20"></g-title>
    <van-collapse v-model="activeNames">
      <van-collapse-item
        v-for="(gItem, gIndex) in allCardGroupArr"
        :key="gIndex"
        :title="gItem.name"
        :name="gIndex"
      >
        <van-radio-group v-model="selectRadio">
          <card-list-com :cardList="gItem.list">
            <template v-slot:icon="slotProps">
              <van-radio
                :name="slotProps.cardItem.Id"
                class="c-p-r-20"
                @click.native.stop="itemCheckHandler(slotProps.cardItem)"
              >
                <template #icon="props">
                  <img
                    style="width: 22px"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  />
                </template>
              </van-radio>
            </template>
          </card-list-com>
          <!-- <van-cell
            v-for="(item, i) in gItem.list"
            :key="i"
            clickable
            @click="handleClickCard(item)"
          >
            <template #title>
              <div class="c-fl">
                <div class="">
                  <g-img
                    :src="item.PhotoUrl || $root.defaultImg"
                    size="160"
                    height="60px"
                    :normal="true"
                    class="l-img c-p-r-20"
                  />
                </div>
                <div class="txt-box">
                  <div class="main-title">{{ item.CardTypeName }}</div>
                  <div class="sub-title">默认次卡：{{ item.TotalItem }}项</div>

                  <div>
                    <span>面值：</span>
                    <span>{{ item.Price }}元</span>
                  </div>
                </div>
              </div>
            </template>
            <template #right-icon>
              <div class="c-fl">
                <g-arrow :width="16"></g-arrow>
              </div>
            </template>
          </van-cell> -->
        </van-radio-group>
      </van-collapse-item>
    </van-collapse>
    <div class="btm c-font-34" @click="handleToNext">下一步</div>

    <!-- <van-popup
      v-model="isShowPerson"
      position="bottom"
      :style="{ height: '65%' }"
    >
      <g-title title="请选择一名会籍顾问"  class="c-p-tb-10 c-p-lr-20"></g-title>
      <van-search
        v-model="searchVal"
        show-action
        placeholder="请搜索名称"
        @search="onSearch"
        @clear="onSearch"
      >
        <template #action>
          <div
            :style="{ color: searchVal.length > 0 ? 'var(--tc)' : '#c8c8c8' }"
            @click="onSearch"
          >
            搜索
          </div>
        </template>
      </van-search>
      <div class="counselor_list_con">
        <van-radio-group v-model="counselorRadio">
          <van-cell-group>
            <van-cell
              v-for="item in memberCounselorList"
              :key="item.UserId"
              :title="`【${item.PositionName}】 ${item.UserName}`"
              clickable
              @click="counselorRadio = item.UserId"
              v-show="item.isShow"
            >
              <template #right-icon>
                <van-radio :name="item.UserId" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <g-bottom-btn title="确定" @click="confirm"></g-bottom-btn>
    </van-popup> -->
  </div>
</template>

<script>
import cardListCom from "@/components/cardListCom";
import { handleLocalStorage } from "@/utils";
import { getEleCardTypeList } from "@/api/member";
export default {
  name: "HandleEleCard",
  props: {},
  components: {
    cardListCom,
  },
  data() {
    return {
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
      allCardGroupArr: [],
      activeNames: [],
      eleCards: [],
      selectRadio: "",
      activeName: [],
      mSeletedCardItem:{}
      // counselorRadio: "",

      // isShowPerson: false,
      // searchVal: "",
      // memberCounselorList: [],
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.handleGetEleCardList();
    },
  },
  created() {
    this.vpnId = this.$store.state.vpnId;
    if (this.vpnId) {
      this.handleGetEleCardList();
    }

    // 进入此页面时清除掉第二步的选择
    this.$store.commit("eleCard/setSecondaryCardList", []);
    this.$store.commit("eleCard/setRechargeInfo", {});
  },
  mounted() {},
  methods: {
    handleGetEleCardList() {
      getEleCardTypeList({ vpnId: this.vpnId }).then((res) => {
        const resData = res.Items;
        let cardGroupArr = [],
          indexArr = [];
        resData.forEach((item, index) => {
          // item.CardRemark = item.CardRemark.split(/\\r\\n/g);
          const nameStr = item.GroupName || "默认分类";
          const findItem = cardGroupArr.find((cItem) => cItem.name == nameStr);
          if (!findItem) {
            cardGroupArr.push({
              name: nameStr,
              isOpen: true,
              list: [item],
            });
            indexArr.push(index);
          } else {
            findItem["list"].push(item);
          }
        });
        this.allCardGroupArr = cardGroupArr;
        this.activeNames = indexArr;
        this.eleCards = resData;
        const preSelectCardType =
          this.$store.state.eleCard.cardTypeObj.Id || undefined;
        const preSelectCardItem = resData.find((item) => {
          return item.Id == preSelectCardType;
        });
        if (preSelectCardType && preSelectCardItem) {
          this.itemCheckHandler(preSelectCardItem);
        } else {
          this.itemCheckHandler(this.eleCards[0]);
        }
      });
    },
    itemCheckHandler(v) {
      this.selectRadio = v.Id;
      this.mSeletedCardItem = v
      // handleLocalStorage.set("cardTypeObj", v);
      this.$store.commit("eleCard/setCardTypeInfo", v);
    },
    // 点击查看卡详情
    // handleClickCard(v) {
    //   this.isCardShow = true;
    //   this.detailInfo = v;
    // },
    handleToNext() {
      this.$store.commit("eleCard/setSecondaryCardList",[]);
      this.$store.commit("eleCard/setRechargeInfo", {});
      this.$router.push({
        name: "CardPay",
        query: {
          cardPayMoney: this.mSeletedCardItem.ShiShou,
          allPayMoney: this.mSeletedCardItem.ShiShou,
          cardTypeName: this.mSeletedCardItem.CardTypeName,
          cardTypeId: this.mSeletedCardItem.CardTypeId,
          fromPage: this.fromPage,
        },
      });

      // this.$router.push({
      //   name: "CardRecharge",
      //   query: { cardId: this.selectRadio },
      // });
    },
    // confirmBuy() {
    //   if (!this.isCheck) {
    //     return this.$toast("请确认您已阅读并同意\n<<办卡须知>>");
    //   }
    //   this.isShowPerson = true;
    //   this.handleGetMemberCounselor();
    // },
    // handleGetMemberCounselor() {
    //   const arrList = [
    //     {
    //       $id: "6",
    //       EmployCardId: "",
    //       Sex: "  ",
    //       PositionSite: "9257389b-1c94-4020-be23-e0e615778727",
    //       Login: "ZXP.",
    //       Password: "",
    //       Birth: "2005-03-28T00:00:00",
    //       Phone: "",
    //       MobilePhone: "",
    //       HomeAddress: "",
    //       PostalCode: "",
    //       Email: "",
    //       SalaryTime: "",
    //       Status: "在职",
    //       ComeTime: "2005-03-28T00:00:00",
    //       IDCard: "",
    //       CoachPrice: 0.0,
    //       Education: "",
    //       PositionName: "开牌组",
    //       Type: "",
    //       BaseSalary: 0.0,
    //       Penalty: 0.0,
    //       DressPrice: 0.0,
    //       DressCount: 0,
    //       DressMoney: 0.0,
    //       TempNumber: "",
    //       TempNumberValidTime: "2005-03-28T00:00:00",
    //       TechPost: "",
    //       Remark: "",
    //       IsGonShang: false,
    //       IsShiYe: false,
    //       IsYangLao: false,
    //       InsureBase: "",
    //       GongShangDate: "",
    //       ShiYeDate: "",
    //       YangLaoDate: "",
    //       ComputerNo: "",
    //       FeeType: "",
    //       LeaveTime: "2005-03-28T00:00:00",
    //       YiLiaoDate: "",
    //       ZhuanZhenTime: "2005-03-28T00:00:00",
    //       ContractEndTime: "2005-03-28T00:00:00",
    //       Suject: "",
    //       IsAllowEnter: "是",
    //       ShouYingRight: null,
    //       SnDefaultQianTai: null,
    //       EncryPwd: null,
    //       LoginPwd: "",
    //       MianDanLimit: 0.0,
    //       BataiRight: null,
    //       Weekend: "",
    //       TempArrearLimit: 0.0,
    //       CompanyId: null,
    //       Prefix: "",
    //       HandPwd: "",
    //       GroupId: 0,
    //       EmployCode: "",
    //       Group: null,
    //       Position: null,
    //       Departments: null,
    //       UserRoles: null,
    //       OneGrift: null,
    //       TotalGrift: null,
    //       ErrorMsg: null,
    //       RequestContext: null,
    //       NameSpell: "ZXP.",
    //       DepartmentName: null,
    //       UserId: "1003",
    //       UserName: "朱喜盼.",
    //       State: 0,
    //     },
    //     {
    //       $id: "7",
    //       EmployCardId: "",
    //       Sex: "  ",
    //       PositionSite: "9257389b-1c94-4020-be23-e0e615778727",
    //       Login: "ZYF",
    //       Password: "",
    //       Birth: "2005-03-28T00:00:00",
    //       Phone: "",
    //       MobilePhone: "",
    //       HomeAddress: "",
    //       PostalCode: "",
    //       Email: "",
    //       SalaryTime: "",
    //       Status: "在职",
    //       ComeTime: "2005-03-28T00:00:00",
    //       IDCard: "",
    //       CoachPrice: 0.0,
    //       Education: "",
    //       PositionName: "开牌组",
    //       Type: "",
    //       BaseSalary: 0.0,
    //       Penalty: 0.0,
    //       DressPrice: 0.0,
    //       DressCount: 0,
    //       DressMoney: 0.0,
    //       TempNumber: "",
    //       TempNumberValidTime: "2005-03-28T00:00:00",
    //       TechPost: "",
    //       Remark: "",
    //       IsGonShang: false,
    //       IsShiYe: false,
    //       IsYangLao: false,
    //       InsureBase: "",
    //       GongShangDate: "",
    //       ShiYeDate: "",
    //       YangLaoDate: "",
    //       ComputerNo: "",
    //       FeeType: "",
    //       LeaveTime: "2005-03-28T00:00:00",
    //       YiLiaoDate: "",
    //       ZhuanZhenTime: "2005-03-28T00:00:00",
    //       ContractEndTime: "2005-03-28T00:00:00",
    //       Suject: "",
    //       IsAllowEnter: "是",
    //       ShouYingRight: null,
    //       SnDefaultQianTai: null,
    //       EncryPwd: null,
    //       LoginPwd: "",
    //       MianDanLimit: 0.0,
    //       BataiRight: null,
    //       Weekend: "",
    //       TempArrearLimit: 0.0,
    //       CompanyId: null,
    //       Prefix: "",
    //       HandPwd: "",
    //       GroupId: 0,
    //       EmployCode: "",
    //       Group: null,
    //       Position: null,
    //       Departments: null,
    //       UserRoles: null,
    //       OneGrift: null,
    //       TotalGrift: null,
    //       ErrorMsg: null,
    //       RequestContext: null,
    //       NameSpell: "ZYF",
    //       DepartmentName: null,
    //       UserId: "1019",
    //       UserName: "张艳凤",
    //       State: 0,
    //     },
    //   ];
    //   this.memberCounselorList = arrList.map((item) => {
    //     return { ...item, isShow: true };
    //   });

    //   this.counselorRadio = this.memberCounselorList[0].UserId;
    // },

    // onSearch(val) {
    //   console.log(val);
    //   if (this.searchVal.length > 0) {
    //     this.memberCounselorList.forEach((item) => {
    //       if (
    //         !item.UserName.includes(this.searchVal) &&
    //         !item.PositionName.includes(this.searchVal)
    //       ) {
    //         item.isShow = false;
    //       }
    //     });
    //   } else {
    //     this.memberCounselorList.forEach((item) => {
    //       item.isShow = true;
    //     });
    //   }
    // },
    // onCancel() {
    //   this.$toast("取消");
    // },
    // confirm() {
    //   this.$router.push("CardPay");
    // },
  },
};
</script>
<style scoped lang="scss">
.top {
  background: #00e8e1;
  color: #000;
}
.txt-box {
  line-height: 40px;
  font-size: 24px;
}
.btm {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 96px;
  line-height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: 100%;
  background: var(--tc);
  color: #fff;
  text-align: center;
}
.secondary_card_con {
  padding-bottom: 120px;
}
.counselor_list_con {
  max-height: 40vh;
  overflow: auto;
}
</style>
